var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 10.4917L14.6583 11.6667L11.6667 8.675L8.675 11.6667L7.5 10.4917L10.4917 7.5L7.5 4.50833L8.675 3.33333L11.6667 6.325L14.6583 3.33333L15.8333 4.50833L12.8417 7.5L15.8333 10.4917ZM18.3333 0C18.7754 0 19.1993 0.175595 19.5118 0.488155C19.8244 0.800716 20 1.22464 20 1.66667V13.3333C20 13.7754 19.8244 14.1993 19.5118 14.5118C19.1993 14.8244 18.7754 15 18.3333 15H5.83333C5.25833 15 4.80833 14.7 4.50833 14.2583L0 7.5L4.50833 0.733333C4.80833 0.291667 5.25833 0 5.83333 0H18.3333ZM18.3333 1.66667H5.83333L1.9 7.5L5.83333 13.3333H18.3333V1.66667Z",
    fill: "#E56A54"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/reset_icon.d7f77bea645f7de4e54a6bb2a4ebc5be.svg";
export { ForwardRef as ReactComponent };